/* unplugin-vue-components disabled */import script from "./gauge.vue?vue&type=script&setup=true&lang=js"
export * from "./gauge.vue?vue&type=script&setup=true&lang=js"

import "./gauge.vue?vue&type=style&index=0&id=861904fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-861904fa"]])

export default __exports__